import React, { useState, useEffect, useMemo } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { db, auth, appId } from '../../firebase-config';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import toast from 'react-hot-toast';

const PrazoCalendario = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const userId = auth.currentUser?.uid;

  useEffect(() => {
    if (!userId) return;

    setLoading(true);
    const prazosQuery = query(collection(db, `artifacts/${appId}/users/${userId}/prazos_historico`));
    const unsubscribe = onSnapshot(prazosQuery, (snapshot) => {
      const allPrazos = snapshot.docs
        .map(doc => ({ ...doc.data(), id: doc.id }))
        .filter(prazo => prazo.dataFim);

      const calendarEvents = allPrazos.map(prazo => {
        const dataFim = prazo.dataFim.toDate ? prazo.dataFim.toDate() : new Date(prazo.dataFim);
        return {
            id: prazo.id,
            title: prazo.descricao || 'Prazo',
            date: dataFim,
            color: prazo.urgente ? '#ef4444' : '#3b82f6',
            extendedProps: {
                ...prazo
            }
        }
      });

      setEvents(calendarEvents);
      setLoading(false);
    }, (error) => {
      console.error("Erro ao carregar prazos:", error);
      toast.error("Não foi possível carregar os prazos do calendário.");
      setLoading(false);
    });

    return () => unsubscribe();
  }, [userId, appId]);

  const handleEventClick = (clickInfo) => {
    const { title, extendedProps } = clickInfo.event;
    toast.custom((t) => (
      <div
        className={`${
          t.visible ? 'animate-enter' : 'animate-leave'
        } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
      >
        <div className="flex-1 w-0 p-4">
          <div className="flex items-start">
            <div className="ml-3 flex-1">
              <p className="text-sm font-medium text-gray-900">
                {title}
              </p>
              <p className="mt-1 text-sm text-gray-500">
                Vencimento em: {new Date(extendedProps.dataFim.seconds * 1000).toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
        <div className="flex border-l border-gray-200">
          <button
            onClick={() => toast.dismiss(t.id)}
            className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-blue-600 hover:text-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Fechar
          </button>
        </div>
      </div>
    ))
  };

  if (loading) {
    return <div className="flex justify-center items-center h-full"><div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-gold"></div></div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="heading-font text-3xl font-bold text-white">Calendário de Prazos</h1>
        <p className="mt-1 text-gray-300">Visualize os seus prazos e compromissos importantes.</p>
      </div>

      <div className="glass-effect rounded-xl p-6">
        <style>
          {`
            .fc .fc-toolbar-title { color: white; font-family: 'Playfair Display', serif; }
            .fc .fc-daygrid-day-number { color: #cbd5e1; }
            .fc .fc-col-header-cell-cushion { color: #D4AF37; }
            .fc-day-today { background-color: rgba(212, 175, 55, 0.15) !important; }
            .fc-button { background-color: #1e3a8a !important; border: 1px solid #3b82f6 !important; }
            .fc-button:hover { background-color: #1e40af !important; }
            .fc-event { border: none !important; padding: 4px; font-size: 0.8rem; cursor: pointer; }
          `}
        </style>
        <FullCalendar
          plugins={[dayGridPlugin]}
          initialView="dayGridMonth"
          events={events}
          eventClick={handleEventClick}
          height="auto"
          locale="pt-br"
          headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth'
          }}
          buttonText={{
            today: 'Hoje',
            month: 'Mês',
          }}
          dayMaxEvents={2}
          moreLinkText="mais"
        />
      </div>
    </div>
  );
};

export default PrazoCalendario;
